exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*listOuterContent*/\n\n/*listContent*/\n\n.aboutPageContributorDividingSpace {\n    padding-bottom: 7vh;\n}\n\n@media (max-width: 992px)\n{\n    .aboutPageOuterContent\n    {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        width: 90%;\n        margin: 0 auto;\n        overflow-wrap: break-word;\n\n        font-size: 14pt;\n        text-align: center;\n    }\n}\n\n@media (min-width: 992px)\n{\n    .aboutPageOuterContent\n    {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        width: 70%;\n        margin: 0 auto;\n        \n        overflow-wrap: break-word;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/aboutPage/aboutPage.component.css
// module id = ../../../../../src/app/components/aboutPage/aboutPage.component.css
// module chunks = main